import { render, staticRenderFns } from "./AffiliateItem.vue?vue&type=template&id=bea1c476"
import script from "./AffiliateItem.vue?vue&type=script&lang=js"
export * from "./AffiliateItem.vue?vue&type=script&lang=js"
import style0 from "./AffiliateItem.vue?vue&type=style&index=0&id=bea1c476&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@6.26.3_cache-loader@4.1.0_webpac_6f95da160c08ac8dc5724deda4dd3901/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports